import { render, staticRenderFns } from "./Castigos.vue?vue&type=template&id=05948766&"
import script from "./Castigos.vue?vue&type=script&lang=js&"
export * from "./Castigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports